module.exports = __webpack_public_path__ + "img/tango_background_hero.4605888b.png";